<template>
  <div id="projects" class="projects">
    <h4 data-aos="fade-up">Projects</h4>    
    <v-content>
      <FruitProject data-aos-delay="100"/>
      <DNAProject data-aos-delay="100"/>
      <FARProject data-aos-delay="100"/>
      <WPProjects data-aos-delay="100"/>
    </v-content>
  </div>
</template>

<script>
import DNAProject from './DNAProject';
import FARProject from './FARProject';
import WPProjects from './WPProjects';
import FruitProject from './FruitProject';

export default {
  name: 'Projects',
  props: {   
    
  },
  components: {
    DNAProject,
    FARProject,
    WPProjects,
    FruitProject
  }
}
</script>

<style scoped>
.projects{
  background: rgba(238,238,238,0.5);
  color: #666;
  overflow: hidden;
  min-height: 500px;
  padding-bottom: 50px;
}
.v-application{
  background: rgba(238,238,238,0.2)!important;
  margin-top: 50px;
  }
  
</style>
